// Sticky header functionality
document.addEventListener("DOMContentLoaded", function () {
  console.log("🏠 Sticky header script starting...");
  
  try {
    const productAtc = document.getElementById("product-atc");
    if (!productAtc) {

      return;
    }
    

    const atcTop = productAtc.offsetTop;

    
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const shouldBeSticky = currentScrollY > atcTop;
      
      // Only log when sticky state changes
      if (productAtc.classList.contains("sticky") !== shouldBeSticky) {
        console.log(`📜 Scroll position: ${currentScrollY}px | Sticky threshold: ${atcTop}px | Making sticky: ${shouldBeSticky}`);
      }
      
      productAtc.classList.toggle("sticky", shouldBeSticky);
    };
    
    handleScroll();
    window.addEventListener("scroll", handleScroll);
  } catch (error) {
    console.error("❌ Error initializing sticky header:", error);
  }
});

// Tab navigation functionality
document.addEventListener("DOMContentLoaded", function () {

  
  try {
    // Find replo sections

    let reploSectionIds = [];
    const reploElements = document.querySelectorAll("#replo-deps-section-settings");

    reploElements.forEach((element, index) => {
      console.log(`   Checking replo element ${index + 1}:`, element);
      if (element.parentElement?.id) {
        reploSectionIds.push(element.parentElement.id);

      } else {
        console.log(`   ❌ Replo element ${index + 1} has no parent with ID`);
      }
    });
    

    const buttons = {
      compare: document.getElementById("compare-button"),
      overview: document.getElementById("overview-button"),
      specs: document.getElementById("specs-button"),
    };
    


    // Get content sections

    const sections = {
      compare: document.querySelector(".compare-section"),
      replo: reploSectionIds.map(id => document.getElementById(id)).filter(Boolean),
      specs: document.querySelector(".specs-section"),
      overview: document.querySelectorAll(".overview-section"),
    };
    

    // Check if we have the minimum required elements
    const hasRequiredButtons = Object.values(buttons).some(button => button !== null);
    const hasRequiredSections = sections.replo.length > 0 || sections.overview.length > 0 || sections.compare || sections.specs;
    

    if (!hasRequiredButtons || !hasRequiredSections) {
      console.warn("⚠️ Required navigation elements not found - tab navigation disabled");
      console.log("💡 Debug info:");
      console.log("   Available buttons:", Object.entries(buttons).filter(([,btn]) => btn).map(([key]) => key));
      console.log("   Available sections:", {
        compare: !!sections.compare,
        specs: !!sections.specs,
        overview: sections.overview.length,
        replo: sections.replo.length
      });
      return;
    }
    

    // Function to switch tabs
    function switchTab(activeTab) {

      try {
        // Remove active class from all buttons
        console.log("   Removing active class from all buttons...");
        Object.entries(buttons).forEach(([key, button]) => {
          if (button) {
            const wasActive = button.classList.contains("active");
            button.classList.remove("active");

          }
        });

        // Add active class to current button
        if (buttons[activeTab]) {
          buttons[activeTab].classList.add("active");

        } else {
          console.warn(`   ⚠️ Button for ${activeTab} not found`);
        }

        // Toggle section visibility

        
        sections.replo.forEach((section, index) => {
          if (section) {
            const shouldHide = activeTab !== "overview";
            section.classList.toggle("hide-section", shouldHide);
      }
        });

        sections.overview.forEach((section, index) => {
          if (section) {
            const shouldHide = activeTab !== "overview";
            section.classList.toggle("hide-section", shouldHide);
            console.log(`     Overview section ${index + 1}: ${shouldHide ? 'hidden' : 'visible'}`);
          }
        });

        if (sections.compare) {
          const shouldHide = activeTab !== "compare";
          sections.compare.classList.toggle("hide-section", shouldHide);
          console.log(`     Compare section: ${shouldHide ? 'hidden' : 'visible'}`);
        }

        if (sections.specs) {
          const shouldHide = activeTab !== "specs";
          sections.specs.classList.toggle("hide-section", shouldHide);
          console.log(`     Specs section: ${shouldHide ? 'hidden' : 'visible'}`);
        }

        // Scroll to top for specs and compare sections
        if (activeTab === "specs" || activeTab === "compare") {
          console.log(`   📜 Scrolling to top for ${activeTab} section`);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
        
        console.log(`✅ Tab switch to ${activeTab} completed successfully`);
      } catch (error) {
        console.error(`❌ Error switching tabs to ${activeTab}:`, error);
      }
    }

    // Event delegation for better compatibility
    console.log("📍 Step 5: Setting up click event listeners...");
    document.addEventListener("click", function (event) {
      try {
        const target = event.target;
        console.log("👆 Click detected on:", target);
        
        // Handle navigation button clicks
        if (target === buttons.compare) {
          console.log("🎯 Compare button clicked");
          event.preventDefault();
          switchTab("compare");
        } else if (target === buttons.overview) {
          console.log("🎯 Overview button clicked");
          event.preventDefault();
          switchTab("overview");
        } else if (target === buttons.specs) {
          console.log("🎯 Specs button clicked");
          event.preventDefault();
          switchTab("specs");
        } else if (target.closest(".s4-buy-button")) {
          console.log("🛒 Buy button clicked");
          // Handle buy button clicks
          event.preventDefault();
          switchTab("overview");
          
          setTimeout(() => {
            console.log("⏱️ Starting buy button scroll handler...");
            try {
              const buyButton = target.closest(".s4-buy-button");
              if (!buyButton) {
                console.warn("   ⚠️ Buy button not found in closest search");
                return;
              }
              console.log("   ✅ Buy button found:", buyButton);

              const href = buyButton.getAttribute("href");
              console.log("   📎 Button href:", href);
              
              if (!href || !href.includes("#")) {
                console.warn("   ⚠️ No valid anchor href found");
                return;
              }

              const targetId = href.split("#")[1];
              console.log("   🎯 Target ID:", targetId);
              
              const targetElement = document.getElementById(targetId);
              if (!targetElement) {
                console.warn(`   ⚠️ Target element not found: ${targetId}`);
                return;
              }
              console.log("   ✅ Target element found:", targetElement);

              // Calculate offset for sticky header
              const stickyHeader = document.querySelector(".product-atc");
              let offset = stickyHeader ? stickyHeader.offsetHeight : 0;
              const isMobile = window.innerWidth <= 768;
              const mobileOffset = isMobile ? 60 : 50;
              offset += mobileOffset;
              
              console.log("   📏 Scroll calculation:");
              console.log(`     Sticky header height: ${stickyHeader ? stickyHeader.offsetHeight : 0}px`);
              console.log(`     Mobile offset: ${mobileOffset}px (is mobile: ${isMobile})`);
              console.log(`     Total offset: ${offset}px`);

              setTimeout(() => {
                const elementTop = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                console.log(`   📜 Scrolling to position: ${elementTop}px`);
                window.scrollTo({ top: elementTop, behavior: "smooth" });
                console.log("   ✅ Scroll initiated");
              }, 200);
            } catch (error) {
              console.error("   ❌ Error handling buy button click:", error);
            }
          }, 300);
        } else {
          // Log non-target clicks for debugging
          const targetInfo = {
            tagName: target.tagName,
            className: target.className,
            id: target.id,
            textContent: target.textContent?.substring(0, 50)
          };
          console.log("👆 Click on non-target element:", targetInfo);
        }
      } catch (error) {
        console.error("❌ Error handling click event:", error);
      }
    });
    


  } catch (error) {
    console.error("❌ Error initializing tab navigation:", error);
  }
});
